import { Link } from 'react-router';
import { PageHeader } from '@/components/PageHeader';
import { Card } from '@/components/Card';
import { Button } from '@/components/Button';
import { AREAS, FASE_ACTUAL } from '@/app/areas';

interface Props {
  ruta: string;
}

const CONTENIDO_POR_FASE: Record<number, string> = {
  2: 'Insumos con sus unidades, registro de compras con costo por unidad, e inventario acumulativo con costo promedio ponderado.',
  3: 'Catalogo de recetas con rendimiento y escalado automatico, mas el calculo de costo por porcion, ganancia y margen.',
  4: 'Menu semanal por fecha, separacion entre dia de venta y dia de preparacion, produccion con descuento de inventario, faltantes y lista de compras.',
  5: 'Registro de ventas reales, destino de las porciones no vendidas, e historial de ingresos, costos y ganancias por dia, semana y mes.',
};

/**
 * Marcador de posicion para las areas de fases posteriores.
 *
 * Existen desde la Fase 1 para que la navegacion completa se pueda probar en el
 * telefono, y para que quede claro que trae cada fase en lugar de mostrar una
 * pantalla en blanco.
 */
export function PlaceholderPage({ ruta }: Props) {
  const area = AREAS.find((a) => a.ruta === ruta);
  if (area === undefined) return null;

  return (
    <div className="space-y-5">
      <PageHeader titulo={area.titulo} descripcion={area.descripcion} />

      <Card className="text-center">
        <p aria-hidden="true" className="text-4xl">
          {area.icono}
        </p>
        <p className="mt-3 font-semibold text-texto">Se construye en la Fase {area.fase}</p>
        <p className="mt-2 text-sm text-texto-suave">
          {CONTENIDO_POR_FASE[area.fase] ?? 'Esta area llega en una fase posterior.'}
        </p>
        <p className="mt-3 text-sm text-texto-tenue">
          Vas en la Fase {FASE_ACTUAL}. Cada fase queda probada antes de empezar la
          siguiente.
        </p>
      </Card>

      <Link to="/">
        <Button variante="secundario">Volver al inicio</Button>
      </Link>
    </div>
  );
}
